import styled from 'styled-components';
import { rem } from 'polished';
import colors from '../../../../utils/colors';

export const StyledPrizeWrap = styled.div`
  h4 {
    font-size: ${rem('14px')};
    letter-spacing: 0.109375rem;
    padding-bottom: ${rem('10px')};
    text-transform: uppercase;
  }

  p {
    margin-bottom: 0;
  }

  .name, .score {
    font-family: FyranSans-Core;
    font-size: ${rem('22px')};
    color: ${colors.WHITE};
    letter-spacing: -0.22px;
    line-height: ${rem('26px')};
  }

  .score {
    color: ${colors.WHITE};
  }

  .text {
  	width: calc(100% - 90px);
  	display:inline-block;
  	vertical-align: top;
  }

  figure {
  	display:inline-block;
  	margin: ${rem('-10px')} ${rem('-10px')} 0 0;
  }

  img {
  	width: 100%;
  	height: auto;
  	max-width: ${rem('88px')};
  }

	${props => props.disabled && `
		pointer-events: none;

		.name, .score {
			color: ${colors.GRAY};
		}
	`}

  ${props => props.withTip && `
    &:before {
      content: '';
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 1rem 1rem 1rem;
      border-color: transparent transparent ${colors.GRAY_DARKER} transparent;
      position: absolute;
      top: -1rem;
      left: calc(50% - 1rem);
    }
  `}
`;


// WEBPACK FOOTER //
// ./src/modules/prize/components/ui/index.js